import PropTypes from 'prop-types';

const MemberAvatar = ({ member }) => {
  if (member.status === 'pending') {
    return (
      <div className="w-8 h-8 rounded-full border-2 border-dashed border-gray-300 flex-shrink-0" />
    );
  }

  if (member.profile_photo) {
    return (
      <img
        src={member.profile_photo}
        alt=""
        className="w-8 h-8 rounded-full object-cover flex-shrink-0"
      />
    );
  }

  const initial = (member.full_name || member.email)[0].toUpperCase();

  return (
    <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
      <span className="text-sm font-medium text-gray-600">
        {initial}
      </span>
    </div>
  );
};

MemberAvatar.propTypes = {
  member: PropTypes.shape({
    status: PropTypes.string.isRequired,
    profile_photo: PropTypes.string,
    full_name: PropTypes.string,
    email: PropTypes.string.isRequired,
  }).isRequired,
};

export default MemberAvatar;
